/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  MarkNotificationsAsReadMutationRequest,
  MarkNotificationsAsReadMutationResponse,
} from '../types/MarkNotificationsAsRead'

function getMarkNotificationsAsReadUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/notifications/mark-as-read/` as const,
  }
  return res
}

/**
 * @summary Mark the supplied notification ids as read
 * {@link /api/v1/notifications/mark-as-read/}
 */
export async function markNotificationsAsRead(
  data: MarkNotificationsAsReadMutationRequest,
  config: Partial<RequestConfig<MarkNotificationsAsReadMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    MarkNotificationsAsReadMutationResponse,
    ResponseErrorConfig<Error>,
    MarkNotificationsAsReadMutationRequest
  >({
    method: 'POST',
    url: getMarkNotificationsAsReadUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
